var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9503 15.0413L29.3429 4.98527L34.7926 3.87426L42.3723 13.9303L36.9503 15.0413ZM28.8173 16.722L21.2376 6.60904L15.7879 7.77701L23.3953 17.833L28.8173 16.722ZM55.955 11.167L53.7972 0L42.9256 2.222L50.5053 12.3065L55.955 11.167ZM48.7072 30.8232C51.7502 30.8232 54.5718 31.6778 57.0062 33.1306V22.277H1.67966V50.7642C1.67966 52.2753 2.26256 53.7245 3.30013 54.7929C4.33771 55.8614 5.74496 56.4617 7.21231 56.4617H34.35C32.9391 53.9548 32.1092 51.0491 32.1092 47.9155C32.1092 38.4862 39.5507 30.8232 48.7072 30.8232ZM7.65492 9.45776L4.94392 9.99902C3.5101 10.3016 2.24997 11.1742 1.4369 12.4275C0.623836 13.6808 0.323406 15.2136 0.60079 16.6935L1.67966 22.277L15.2347 19.5138L7.65492 9.45776ZM58.5 41.8762L54.5718 37.8595L48.7072 43.8988L42.8426 37.8595L38.9421 41.8762L44.8067 47.9155L38.9421 53.9548L42.8426 58L48.7072 51.9322L54.5718 58L58.5 53.9548L52.6077 47.9155L58.5 41.8762Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.1ee593cb08f6a9ba6b8fd98e2e8bdc9f.svg";
export { ForwardRef as ReactComponent };